import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable'

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(private http: HttpClient) { }

  getBeer() {
  	return this.http.get('https://api.openbrewerydb.org/breweries')
  }

  ffs_pendientes(): Observable<object> {
  	// console.log("estamos en el servicio ffs")
  	let respuesta = this.http.get('https://vertigofin.herokuapp.com/query_consignors.json')
  	// console.log(respuesta)
  	return respuesta
  
  }

  enviar_shopiauth(shop){
    // console.log("estamos en el servicio enviar_shopiauth")
    let respuesta = this.http.post('https://vertigofin.herokuapp.com/recibir_shopi_auth', 
    // let respuesta = this.http.post('http://localhost:3000/recibir_shopi_auth', 
    {
      "shop": shop
    }
    ).subscribe(
      data  => {
      // console.log("POST Request is successful ", data);
      return data
      },
      error  => {

      // console.log("Error", error);

      }

      );
  }

  pedir_token(shop, consignor_id, code){
    // console.log("estamos en el servicio enviar_shopiauth")
    let respuesta = this.http.post('https://vertigofin.herokuapp.com/pedir_token', 
    // let respuesta = this.http.post('http://localhost:3000/recibir_shopi_auth', 
    {
      "shop": shop, 
      "consignor_id": consignor_id, 
      "code": code
    }
    ).subscribe(
      data  => {
      // console.log("POST Request is successful ", data);
      },
      error  => {

      // console.log("Error", error);

      }

      );
  }



}
